import React from 'react'
import { router, usePage, useForm } from '@inertiajs/react'
import {
  Box, Button, TextField, Select, MenuItem, FormControl, InputLabel,
  Paper, Grid, FormControlLabel, Checkbox,
} from '@mui/material'
import AppShell from '../../../../components/layout/AppShell'
import PageHeader from '../../../../components/ui/PageHeader'

Form.layout = (page) => <AppShell>{page}</AppShell>

const DATA_TYPE_OPTIONS = [
  { value: 'decimal', label: 'Dezimal' },
  { value: 'integer', label: 'Ganzzahl' },
  { value: 'string', label: 'Text' },
]

export default function Form({ property, attribute_type, action, errors: serverErrors = {} }) {
  const { props } = usePage()
  const tenant = props.tenant || {}
  const basePath = `/m/${tenant.slug}/properties/${property.id}/unit_attribute_types`
  const isEdit = action === 'edit'

  const { data, setData, post, put, processing, errors } = useForm({
    name: attribute_type.name || '',
    data_type: attribute_type.data_type || 'decimal',
    unit_of_measure: attribute_type.unit_of_measure || '',
    required_for_weg: attribute_type.required_for_weg || false,
    usable_as_distribution_key: attribute_type.usable_as_distribution_key || false,
  })

  const allErrors = { ...serverErrors, ...errors }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (isEdit) {
      put(`${basePath}/${attribute_type.id}`, { data: { unit_attribute_type: data } })
    } else {
      post(basePath, { data: { unit_attribute_type: data } })
    }
  }

  return (
    <Box>
      <PageHeader
        title={isEdit ? 'Attributtyp bearbeiten' : 'Neuer Attributtyp'}
        breadcrumbs={[
          { label: 'Attributtypen', href: basePath },
          { label: isEdit ? attribute_type.name : 'Neu' },
        ]}
      />

      <Paper elevation={0} sx={{ p: 3, border: '1px solid', borderColor: 'divider' }}>
        <form onSubmit={handleSubmit} data-testid="attr-type-form">
          <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
              <TextField
                label="Name"
                value={data.name}
                onChange={(e) => setData('name', e.target.value)}
                error={!!allErrors.name}
                helperText={allErrors.name}
                fullWidth
                required
                data-testid="name-input"
              />
            </Grid>

            <Grid size={{ xs: 12 }}>
              <FormControl fullWidth>
                <InputLabel>Datentyp</InputLabel>
                <Select
                  value={data.data_type}
                  onChange={(e) => setData('data_type', e.target.value)}
                  label="Datentyp"
                  data-testid="data-type-select"
                >
                  {DATA_TYPE_OPTIONS.map((opt) => (
                    <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid size={{ xs: 12 }}>
              <TextField
                label="Maßeinheit"
                value={data.unit_of_measure}
                onChange={(e) => setData('unit_of_measure', e.target.value)}
                fullWidth
                placeholder="z.B. m², ‰, kWh"
                data-testid="unit-of-measure-input"
              />
            </Grid>

            <Grid size={{ xs: 12 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={data.required_for_weg}
                    onChange={(e) => setData('required_for_weg', e.target.checked)}
                    data-testid="required-for-weg-checkbox"
                  />
                }
                label="Pflichtfeld für WEG"
              />
            </Grid>

            <Grid size={{ xs: 12 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={data.usable_as_distribution_key}
                    onChange={(e) => setData('usable_as_distribution_key', e.target.checked)}
                    data-testid="usable-as-dk-checkbox"
                  />
                }
                label="Nutzbar als Verteilerschlüssel"
              />
            </Grid>

            <Grid size={{ xs: 12 }}>
              <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                <Button type="submit" variant="contained" disabled={processing}
                  data-testid="submit-btn">
                  {isEdit ? 'Speichern' : 'Anlegen'}
                </Button>
                <Button variant="outlined" onClick={() => router.visit(basePath)}
                  data-testid="cancel-btn">
                  Abbrechen
                </Button>
              </Box>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </Box>
  )
}
